export default __webpack_public_path__ + "static/media/team-standards.aa22d823.pdf";